import React from "react";
import '../style/Home.css';
import { Link } from "react-router-dom";
export default function Home() {
    return (
        <>
            <header>
                <h1>We provide you quality service  on 3D Modelling</h1>
                <p className="lead mb-3">We have been providing reliable customer service for several years</p>
                <div className="linb">
                <Link className="butt  mt-5" to="/order">Order A Project</Link>
                <Link className="butt- mt-5 " to="/portfolio"> Our Portfolio</Link>
                </div>
            </header>
            <section className="section-1">
                <h1 className="text-center pt-5">Our results</h1>
                <div className="sec-1">
                    <div className="box-1">
                        <h1 className="text-center">25 000+</h1>
                        <p className="text-center">Muvaffaqiyatli loyihalar</p>
                        <img src={require("../img/win.png")} alt="Error" />
                    </div>
                    <div className="box-1 box-1-">
                        <h1 className="text-center">25 000+</h1>
                        <p className="text-center">Muvaffaqiyatli loyihalar</p>
                        <img className="imgg" src={require("../img/guarantee.png")} alt="Error" />
                    </div>
                    <div className="box-1">
                        <h1 className="text-center">25 000+</h1>
                        <p className="text-center">Muvaffaqiyatli loyihalar</p>
                        <img src={require("../img/rocket.png")} alt="Error" />
                    </div>
                </div>
            </section>
            <section className="section-2">
                <div className="sec-2 ">
                    <div className="img w-50">
                        <img src={require("../img/home-2.png")} alt="Error" />
                    </div>
                    <div className="text ">
                        <h1 className="fw-bold">About</h1>
                        <p>
                            We create digital experiences fully crafted to support your brand. Leveraging on web standards, usability and best practices, the results are fast, responsive, and mobile-optimized. We develop sites to deliver online conversions and frictionless user engagement. Designing flexible and easy to manage back-end foundations with a goal of crafting innovative, future-proofed web solutions.

                            We create digital experiences fully crafted to support your brand. Leveraging on web standards, usability and best practices, the results are fast, responsive, and mobile-optimized. We develop sites to deliver online
                        </p>
                    </div>
                </div>
            </section>
            <section className="section-3">
                <h1 className="text-center mb-5 fw-bold">Our works</h1>
                <div className="sec-3">
                    <div className="box-3">
                        <div className="boxbox-3">
                            <img src={require("../img/home-3.png")} alt="Error" />
                        </div>
                        <div className="boxbox-3">
                            <img src={require("../img/home-4.png")} alt="Error" />
                        </div>
                        <div className="boxbox-3">
                            <img src={require("../img/home-5.png")} alt="Error" />
                        </div>

                    </div>
                    <div className="box-3_right">
                        <div className="boxbox-3">
                            <img src={require("../img/home-3.png")} alt="Error" />
                        </div>
                        <div className="boxbox-3">
                            <img src={require("../img/home-4.png")} alt="Error" />
                        </div>
                        <div className="boxbox-3">
                            <img src={require("../img/home-5.png")} alt="Error" />
                        </div>
                    </div>
                    <div className="link">
                <Link className="lin btn btn-6" to="/portfolio">See more</Link>
                    </div>
                </div>

            </section>
            <section className="section-4 mt-5 ">
                <div className="sec-4">
                    <div className="box-4">
                        <h2 className="fw-bold  text-center mt-5">25 000+</h2>
                        <p className="text-center ">Muvaffaqiyatli loyihalar</p>
                        <div className="i">
                            <i class="fa-solid fa-cubes"></i>
                        </div>
                    </div>
                    <div className="box-4 box-4-">
                        <h1 className="fw-bold  text-center mt-5">25 000+</h1>
                        <p className="text-center ">Muvaffaqiyatli loyihalar</p>
                        <div className="i ii">
                            <i class="fa-solid fa-bars-progress"></i>
                        </div>
                    </div>
                    <div className="box-4">
                        <h1 className="fw-bold text-center mt-5">25 000+</h1>
                        <p className="text-center">Muvaffaqiyatli loyihalar</p>
                        <div className="i i_ ">
                            <i class="fa-solid fa-bars"></i>
                        </div>
                    </div>
                </div>
                <div className="link ">
                    <Link className="btn" to="/order">Order A Project</Link>
                </div>
            </section>
            <footer >
                <div className="foot ">
                    <h1 className="mt-5 fw-bold  pt-5">Biz bilan hamkor bo’ling</h1>
                    <p className="text-secondary lead">Biz sifatli va ajoyib modellarni sizga taqdim qilamiz</p>
                    <div className="l">
                        <Link className="but mt-5" to="/order">Order A Project</Link>
                    </div>
                </div>
                <div className="foot-  d-flex justify-content-between">
                    <img src={require("../dizipro.png")} alt="Error" />
                    <div className="nav-menu">
                        <Link className="nav-item text-light  " to="/">Home</Link>
                        <Link className="nav-item text-light  " to="/portfolio">Portfolio</Link>
                        <Link className="nav-item text-light  " to="/order">Order A Project</Link>
                        <Link className="nav-item text-light  " to="/paid">Paid Courses</Link>
                        <Link className="nav-item text-light  " to="/profil">Profil</Link>
                    </div>
                    <div className="i">
                        <i class="fa-brands fa-instagram"></i>
                        <i class="fa-brands fa-telegram"></i>
                        <i class="fa-brands fa-facebook"></i>
                    </div>
                </div>
            </footer>
        </>
    )
}